<template>
  <ContentList :type="statuses_.accepted"/>
</template>

<script>
import ContentList from '@/components/content/verification/ContentList.vue'
import { statuses } from '@/config/content/statuses'

export default {
  name: 'ContentAccepted',
  components: { ContentList },
  data() {
    return {
      statuses_: statuses
    }
  }
}
</script>

<style scoped>

</style>
